export const vehicleTrackingConstants = {
  GET_VEHICLES: 'GET_VEHICLES',
  GET_VEHICLES_SUCCESS: 'GET_VEHICLES_SUCCESS',
  GET_VEHICLES_FAILURE: 'GET_VEHICLES_FAILURE'
}
